// #region Imports
import { defineComponent } from "vue";
// #endregion
export default defineComponent({
    // #region Constructor
    emits: ['ValueChanged', 'validate', 'update:modelValue'],
    // #endregion
    // #region Properties
    props: {
        dataObject: {
            type: Object,
            required: false,
            default: null,
        },
        dataMember: {
            type: String,
            required: false,
            default: ''
        },
        dataMode: {
            type: String,
            required: false,
            default: 'form',
            validValues: ['form', 'model', 'props'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['form', 'model', 'props'].includes(value);
            }
        },
        modelValue: {
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        validationRules: {
            type: Object,
            required: false,
            default: {},
        },
        formContext: {
            type: Object,
            required: false,
            default: undefined,
        }
    },
    data: () => ({
        errorMessage: null,
        internalValue: null,
        watcher: null,
        dataType: 'text'
    }),
    // #endregion
    // #region Constructor
    beforeMount() {
        // #region Context
        if (this.formContext) {
            //new
            if (!this.formContext.fields) {
                this.formContext.fields = [];
            }
            //Append
            if (!this.formContext.fields.find((e) => e === this)) {
                this.formContext.fields.push(this);
            }
        }
        // #endregion
        // #region Form
        //Run
        this.$form = this.formContext?.validation ?? utils.findForm(this);
        //Value
        if (!utils.isNullOrEmpty(this.dataMember) && !utils.isNull(this.modelValue)) {
            if (this.dataType === 'number') {
                this.$form?.registerValue(this.dataMember, utils.toNumber(this.modelValue));
            }
            else {
                this.$form?.registerValue(this.dataMember, this.modelValue);
            }
        }
        //Run
        this.$form?.registerField(this);
        // #endregion
        // #region Values
        //Valueeit
        this.updateInternalValue();
        //Batcher
        if (!this.hasObjectMember) {
            //Do nothing   
        }
        else if (this.dataMode === 'model') {
            this.watcher = this.$watch(() => { return utils.getObjectValue(this.dataObject, this.dataMember); }, (oldValue, newValue) => {
                this.internalValue = oldValue;
            });
        }
        else {
            this.watcher = this.$watch(() => { return utils.getObjectValue(this.$form?.data, this.dataMember); }, (oldValue, newValue) => {
                this.internalValue = oldValue;
            });
        }
        // #endregion
    },
    beforeUnmount() {
        //Unatc
        if (this.watcher) {
            this.watcher();
        }
        //Remove
        if (this.formContext && this.formContext.fields) {
            let tField = this.formContext.fields.indexOf(this);
            if (tField) {
                this.formContext.fields.splice(tField, 1);
            }
        }
        //Field
        this.$form?.unregisterField(this);
    },
    // #endregion
    // #region Core
    computed: {
        validationState() {
            if (utils.isNullOrEmpty(this.errorMessage)) {
                return "valid";
            }
            else {
                return "invalid";
            }
        },
        hasObjectMember() {
            if (utils.isNullOrEmpty(this.dataMember)) {
                return false;
            }
            return true;
        },
        isInvalid() {
            return this.validationState === 'invalid';
        },
    },
    watch: {
        'internalValue': function (newValue, oldValue) {
            // #region Set
            if (!this.hasObjectMember) {
                this.$emit('update:modelValue', this.internalValue);
            }
            else if (this.dataMode === 'model') {
                utils.setObjectValue(this.dataObject, this.dataMember, this.internalValue);
            }
            else {
                utils.setObjectValue(utils.findForm(this)?.data, this.dataMember, this.internalValue);
            }
            // #endregion
            // #region Event
            this.$emit('ValueChanged', { sender: this, dataObject: this.dataObject, dataMember: this.dataMember, value: this.internalValue });
            // #endregion
        },
    },
    methods: {
        updateInternalValue() {
            if (!this.hasObjectMember) {
                this.internalValue = this.modelValue;
            }
            else if (this.dataMode === 'model') {
                this.internalValue = utils.getObjectValue(this.dataObject, this.dataMember);
            }
            else {
                this.internalValue = utils.getObjectValue(utils.findForm(this)?.data, this.dataMember);
            }
        },
        getObject() {
            if (this.dataMode === 'model') {
                return this.dataObject;
            }
            else {
                return utils.findForm(this)?.data;
            }
        },
        setObjectValue(member, value) {
            if (member === '$' || member === this.dataMember) {
                this.internalValue = value;
            }
            else {
                if (this.dataMode === 'model') {
                    utils.setObjectValue(this.dataObject, member, value);
                }
                else {
                    utils.setObjectValue(utils.findForm(this)?.data, member, value);
                }
            }
        },
        onFocusOut(event) {
            //Value
            this.$form?.validateField(this);
            //Event
            this.$emit('validate', event);
        },
        validate() {
            this.$form?.validateField(this);
        },
        validateForm() {
            return this.$form?.validate() ?? false;
        }
    }
    // #endregion
});
